module.exports = __webpack_public_path__ + "img/wx_pay_desc.1c5b2155.png";